module.exports = __webpack_public_path__ + "static/media/yoga poses.97615bcc.jpg";